// Definitions
// ---------------------------------------------------------------------------

export const SortOptions = {
  activity: {
    field: ['lastActivityAt'],
    order: ['desc']
  },
  recent: {
    field: ['createdAt'],
    order: ['desc']
  },
  older: {
    field: ['createdAt'],
    order: ['asc']
  },
  unread: {
    field: ['currentUser.visited', 'lastActivityAt'],
    order: ['asc', 'desc']
  },
  comment: {
    field: ['lastComment', 'createdAt'],
    order: ['desc', 'desc']
  },
  priority: {
    field: ['prioritySorter', 'createdAt'],
    order: ['desc', 'desc']
  },
  favorite: {
    field: ['currentUser.favorited', 'createdAt'],
    order: ['desc', 'desc']
  }
}

export const LocalStorage = {
  PENDING_MESSAGE: 'pending_message',
  TOKEN_EXP: 'lme',
  PROMPT_IOS: 'prompt_ios',
  CHECKOUT_DATA: 'chekcout_data'
}

export const ErrorCodes = {
  TOKEN_EXPIRED: 101,
  ACCESS_CONTROL: 102,
  LANDSCAPE_LOCKED: 104
}

export const ButtonType = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  FLAT: 'flat',
  OUTLINE: 'outline',
  WARNING: 'warning',
  ACCENT: 'accent'
}

export const Alert = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
}

export const AlertMessages = {
  START_PAGE: 'Default start page changed.',
  TAGS_DELETE: 'Tags successfully deleted',
  TAGS_MERGE: 'Tags successfully merged',
  LANDSCAPE_EDIT: 'Landscape ##landscape## successfully updated',
  INSIGHTS_SETTINGS_EDIT: 'updated', // resource+
  INSIGHTS_SETTINGS_RESET: 'restored to default', // resource+
  INSIGHTS_SETTINGS_DELETED: 'deleted', // resource+
  FEEDBACK_NEW_TOPIC:
    'Congratulations on creating your first topic and thank you for your contribution to ##landscape##',
  MODAL_DIRTY:
    'You have unsaved changes that will be lost if you decide to continue. \n Are you sure you want to leave?',
  NEW_ACCOUNT: 'Account successfully created! Please log in for the first time',
  NEW_ACCOUNT_BUT_LOGGED_IN:
    'You are currently logged in as ##user##. Log out first and access with your new user',
  EMAIL_VERIFICATION: 'Your email was verified. Thank you',
  CONNECTION_LOST: 'There is no Internet connection',
  CONNECTION_REESTABLISHED: 'Connection reestablished',
  FEEDBACK_SUCCESS: 'Thanks for your feedback! :)',
  BUSINESS_CONTACT_SUCCESS:
    'Thanks for contacting us. We will get in touch with you shortly.',
  CONTACT_ERROR: 'There was an error sending your message. Please try again', // +error
  ACTOR_NOT_FOUND: 'not found. You have been redirect to', // +actorName/+newActorName
  TOKEN_EXPIRED: 'Your session has expired. Please log in again',
  TOKEN_INVALID:
    'There was an error validating your session. Please log in again',
  RENEW_TOKEN_ERROR: 'Delegation error:', // +error
  RENEW_TOKEN_ATTEMPT:
    'Not connected. Attempting to reconnect in 10 seconds...', // +errorTokenCount
  RENEW_TOKEN_SUCCESS: 'Connection is reestablished',
  RENEW_TOKEN_FATAL_ERROR:
    'Failed to connect. Please, try to refresh the page manually',
  LOGIN_ERROR: 'Login error:', // +error
  SIGNUP_ERROR: 'Signup error:', // +error
  RESET_MESSAGE:
    'An email with password reset instructions has been sent to your email address, if it exists on our system.',
  VALIDATE_UNKNOWN_ERROR: "It's not possible to validate this user (error 751)",
  API_ERROR: 'There was an error processing this request...',
  CONFIRM_LANDSCAPE: 'Welcome to', // +landscapeName
  REJECT_LANDSCAPE: 'You have rejected the invitation to', // +landscapeName
  ACTOR_CREATED: 'New actor created',
  ACTOR_EDITED: 'Actor edited',
  ACTOR_SQUASHED: 'Actor successfully squashed',
  ACTOR_MERGED: 'Actor successfully merged',
  ACTOR_MOVED: 'Actor successfully moved',
  ACTION_FORBIDDEN: 'You do not have permission to perform this action',
  PROFILE_UPDATED: 'Your profile has been updated',
  ACCESS_CONTROL_ERROR:
    'You cannot ##action## at this moment because your account is on a limited plan',
  SUBSCRIPTION_SUCCESS: 'You have successfully changed your plan',
  PREMIUM_SUCCESS:
    'Welcome to Landscape Monitor Premium. Your support makes us better!',
  DELETE_CARD_FORBIDDEN:
    'You are in a subscription plan. Please add another card before attempting to remove this one',
  DIGEST_SUCCESS: 'Preferences updated',
  DIGEST_ERROR:
    'There was an error updating your preferences. Please try again', // +error,
  NETWORK_ERROR:
    'Network Error. Please review your Network and Firewall configuration if this persists.',
  DELETE_LANDSCAPE: 'successfully deleted', // landscapeName+,
  LEAVE_LANDSCAPE: 'You are no longer a member of' // +landscapeName,
}

export const HelpMessages = {
  ACTOR_LIMIT_EXCEEDED: 'You have reached the limit of actors at this level.'
}

export const Events = {
  CHANGE_STEP: 'change-step',
  NEXT_STEP: 'next-step',
  PREV_STEP: 'prev-step',
  BEFORE_OPEN: 'before-open',
  AFTER_OPEN: 'after-open',
  BEFORE_CLOSE: 'before-close',
  AFTER_CLOSE: 'after-close',
  CLOSE_MODAL: 'close-modal',
  MODAL_CLOSED: 'modal-closed',
  STRIPE_CHECKOUT: 'stripe-checkout',
  STRIPE_PORTAL: 'stripe-portal',
  STRIPE_CARD: 'stripe-card',
  STATS_FILTER_ON: 'stats-filters-on',
  STATS_FILTER_OFF: 'stats-filters-off',
  OPEN_SIDENAV: 'open-sidenav',
  CLOSE_SIDENAV: 'close-sidenav',
  OPEN_TREE: 'open-tree',
  CLOSE_TREE: 'close-tree',
  TOGGLE_TREE: 'toggle-tree',
  OPEN_CONFIRM: 'open-confirm',
  SUBMIT: 'submit',
  SUBMIT_FAILS: 'submit-fails',
  TIMED_OUT: 'timed-out',
  LOCK_APP: 'lock-app',
  SHOW_ALERT: 'show-alert',
  SHOW_SNACKBAR: 'show-snackbar',
  OPEN_TOPIC: 'open-topic',
  SHOW_RELOAD_WARNING: 'show-reload-warning',
  TOPIC_FROM_URL: 'topic-from-url',
  TOPIC_DELETED: 'topic-from-url',
  ACTOR_SELECTED: 'actor-selected',
  ACTOR_UNSELECTED: 'actor-unselected',
  REPLY_COMMENT: 'reply-comment',
  OPEN_FILTER_LIST: 'open-filter-list',
  UPDATE_FILTER_LIST: 'update-filter-list',
  CLOSE_FILTER_LIST: 'close-filter-list',
  SELECT_FILTER_LIST: 'select-filter-list',
  DO_SELECT_FILTER_LIST: 'do-select-filter-list',
  NEXT_SELECT_FILTER_LIST: 'next-select-filter-list',
  PREV_SELECT_FILTER_LIST: 'prev-select-filter-list'
}

export const ModalType = {
  MODAL: 'modal',
  SUBMODAL: 'submodal',
  TOPIC: 'topic',
  EDIT_FEED_SOURCE: 'editFeedSource',
  FILTER_FEEDS: 'filterFeeds',
  DELETE_CONFIRMATION: 'deleteConfirmation'
}

export const Modal = {
  INTERFACE_TOUR: 'interfaceTour',
  MATRIX_PREVIEW: 'matrixPreview',
  UPSERT_TAG: 'upsertTag',
  MERGE_TAGS: 'mergeTags',
  NEW_AXIS: 'newAxis',
  EDITOR_HELP: 'editorHelp',
  FILTER_FEEDS: 'filterFeeds',
  GLOBAL_SOURCE_FILTERS: 'globalSourceFilters',
  TOPIC_FROM_URL: 'topicFromUrl',
  TOPIC_SEARCHER: 'topicsSearcher',
  NEW_PREMISE: 'newPremise',
  EDIT_PREMISE: 'editPremise',
  EDIT_PREMISE_COMMENT: 'editPremiseComment',
  NEW_INSIGHT: 'newInsight',
  EDIT_INSIGHT: 'editInsight',
  EDIT_INSIGHT_COMMENT: 'editInsightComment',
  DIGEST: 'digest',
  WHATS_NEW: 'whatsNew',
  BUSINESS_CONTACT: 'businessContact',
  CONTACT_ACTOR: 'contactActor',
  FEEDBACK: 'feedback',
  NEW_LANDSCAPE: 'newLandscape',
  EDIT_LANDSCAPE: 'editLandscape',
  START_PAGE: 'startPage',
  NEW_ACTOR: 'newActor',
  EDIT_ACTOR: 'editActor',
  MERGE_ACTOR: 'mergeActor',
  SQUASH_ACTOR: 'squashActor',
  MOVE_ACTOR: 'moveActor',
  TOPIC: 'topic',
  NEW_TOPIC: 'newTopic',
  EDIT_TOPIC: 'editTopic',
  MOVE_TOPICS: 'moveTopics',
  EDIT_COMMENT: 'editComment',
  TOPIC_TO_INSIGHT: 'topicToInsight',
  TOPIC_TO_PREMISE: 'topicToPremise',
  CHANGE_PASSWORD: 'changePassword',
  MANAGER: 'manager',
  USER_LIST: 'userList',
  MENTION_LIST: 'mentionList',
  ACTOR_PROFILE: 'actorProfile',
  CONFIRM_LANDSCAPE: 'confirmLandscape',
  NEW_FEED_SOURCE: 'newFeedSource',
  NEW_SEARCH_SOURCE: 'newSearchSource',
  NEW_ACCESO_SOURCE: 'newAccesoSource',
  NEWSLETTER_SIGNUP: 'newsletterSignup',
  EDIT_FEED_SOURCE: 'editFeedSource',
  NEW_FEED_CHANNEL: 'newFeedChannel',
  EDIT_FEED_CHANNEL: 'newEditChannel',
  NEW_FEED_PIPE: 'newFeedPipe',
  NEW_TOPIC_FROM_FEED: 'newTopicFromFeed',
  BILLING_NEXT: 'billingNext',
  PREMIUM_PLAN: 'premiumPlan',
  FREE_PLAN: 'freePlan',
  UPGRADE_PLAN: 'upgradePlan',
  CONFIRM_DELETE: 'confirmDelete'
}

export const Plans = {
  FREE: 'free',
  PREMIUM: 'premium',
  BUSINESS: 'business',
  TRIAL: 'trial'
}

export const Endpoints = {
  LOGIN: '/users/login',
  LANDSCAPE: '/landscapes',
  ACTORS: '/actors',
  TOPICS: '/landscapes/1/topics',
  PROFILE: '/users/profile',
  SUPERADMIN: '/superadmin'
}

/* Do not change order !! */
export const FeedSources = {
  LMSEARCH: 'LMSEARCH',
  NEWSLETTER: 'NEWSLETTER',
  RSS: 'RSS',
  TWITTER: 'TWITTER',
  YOUTUBE: 'YOUTUBE',
  VIMEO: 'VIMEO',
  MEDIUM: 'MEDIUM',
  SLIDESHARE: 'SLIDESHARE',
  REDDIT: 'REDDIT',
  TELEGRAM: 'TELEGRAM',
  CHANNEL: 'CHANNEL',
  ACCESO: 'ACCESO',
  PIPE: 'PIPE',
  WATSON: 'WATSON' // TODO: ??
}

export const FeedSourcesLabels = {
  LMSEARCH: 'Landscape Search',
  NEWSLETTER: 'Newsletter',
  RSS: 'RSS',
  TWITTER: 'Twitter',
  YOUTUBE: 'YouTube',
  VIMEO: 'Vimeo',
  MEDIUM: 'Medium',
  SLIDESHARE: 'SlideShare',
  REDDIT: 'Reddit',
  TELEGRAM: 'Telegram Channel',
  CHANNEL: 'Curated Channel',
  ACCESO: 'Acceso',
  PIPE: 'Pipe',
  WATSON: 'AI recommendation'
}

export const FeedSourcesDescription = {
  LMSEARCH: 'Search any text to get a related news feed',
  RSS: 'Subscribe to a classic RSS feed',
  TWITTER: 'Get recent tweets of a particular user',
  YOUTUBE: 'Subscribe to a user, channel or playlist from Youtube',
  VIMEO: 'Subscribe to a user or channel from Vimeo',
  NEWSLETTER: 'Subscribe to any email newsletter',
  MEDIUM: 'Follow a Medium user or subscribe to publications',
  SLIDESHARE: 'Follow a specific SlideShare user',
  REDDIT: 'Subscribe to updates on any Subreddit',
  TELEGRAM: 'Subscribe to any Telegram channel',
  CHANNEL: 'Feeds on a specific theme carefully selected from external sources',
  ACCESO: 'Feed from Acceso newsletter',
  PIPE: 'Subscribe to curated lists of sources, grouped by themes',
  WATSON: 'AI recommendation' // TODO: ??
}

export const ErrorType = {
  API_ERROR: 'api_error',
  NO_PERMISSION: 'no_permission',
  NO_SOURCES: 'no_sources_created', // used in feeds
  NO_FEED_SOURCES: 'no_feed_sources', // used in feed sources
  SOURCES_NO_CONTENT: 'sources_no_content',
  FILTERS_ACTIVE: 'filters_active'
}

export const ListView = {
  CARD_VIEW: 'cardView',
  COMPACT_VIEW: 'compactView',
  MINIMAL_VIEW: 'minimalView',
  GRID_VIEW: 'gridView',
  BULK_VIEW: 'bulkView'
}

export const PremiseStatus = {
  TESTING: 'testing',
  VALIDATED: 'validated',
  REJECTED: 'rejected'
}

export const AccessControl = {
  SCORES: 'SCORES', // :boolean
  OUTPUTS: 'OUTPUTS', // :boolean
  ACTORS_MAX_WIDTH: 'ACTORS_MAX_WIDTH', // :uint
  ACTORS_MAX_LEVEL: 'ACTORS_MAX_LEVEL', // :uint
  INVITES_PENDING: 'INVITES_PENDING', // :dictionary
  FEEDS_PENDING: 'FEEDS_PENDING', // :uint
  INDICATORS_PENDING: 'INDICATORS_PENDING', // :uint
  LANDSCAPES_PENDING: 'LANDSCAPES_PENDING', // :uint
  WORDCLOUD: 'WORDCLOUD', // :boolean
  WATSON_KEYWORDS: 'WATSON_KEYWORDS' // :boolean
}

export const PlanCycle = {
  DAILY: 'daily',
  MONTHLY: 'monthly',
  YEARLY: 'yearly'
}
export const Roles = {
  MEMBER: 'MEMBER',
  MANAGER: 'MANAGER',
  ADMIN: 'ADMIN',
  OWNER: 'OWNER'
}

export const RoleWeights = {
  [Roles.MEMBER]: 0,
  [Roles.MANAGER]: 1,
  [Roles.ADMIN]: 2,
  [Roles.OWNER]: 3
}

export const Formats = {
  LINK: 'link',
  IMAGE: 'image',
  IFRAME: 'iframe'
}

export const DateUnit = 1000 * 60 * 60 * 24
export const DateFilterOptions = {
  'All time': 'all',
  '1 year': DateUnit * 365,
  '3 months': DateUnit * 30 * 3,
  '1 month': DateUnit * 30,
  '1 week': DateUnit * 7
  // 'Fixed': 'fixed'
}

export const TOPIC_NOT_FROM_FEEDS = 'not from feeds'

export const TopicFilters = {
  SHOW_UNREAD: 'showUnread',
  SHOW_IMPORTANT: 'showImportant',
  HIDE_DESCENDANTS: 'hideDescendants'
}

export const TopicFiltersLabel = {
  SHOW_UNREAD: 'Unread topics',
  SHOW_IMPORTANT: 'Important topics',
  HIDE_DESCENDANTS: 'Hide topics from Subactors'
}

export const Order = {
  ASC: 'asc',
  DESC: 'desc',
  SCORE: 'score',
  PUBDATE: 'pubdate',
  ACTIVITY: 'activity',
  RECENT: 'recent',
  OLDER: 'older',
  UNREAD: 'unread',
  PRIORITY: 'priority',
  FAVORITE: 'favorite',
  COMMENT: 'comment',
  TITLE: 'title',
  FETCHED: 'fetched',
  VIEWS: 'views',
  VOTES: 'votes',
  NAME: 'name',
  JOINED_NEW: 'joined_new',
  JOINED_OLD: 'joined_old',
  FAVORITE_LANDSCAPE: 'favorite_landscape',
  ROLE: 'role'
}

export const MentionTypes = {
  ACTOR: 'ACTOR',
  PREMISE: 'PREMISE',
  INSIGHT: 'INSIGHT',
  TOPIC: 'TOPIC',
  COMMENT: 'COMMENT',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED'
}

export const MentionActions = {
  MENTION: 'MENTION',
  PRIORITY: 'PRIORITY',
  CREATED: 'CREATED',
  ASSIGNED: 'ASSIGNED',
  VOTED: 'VOTED',
  FLAGGED: 'FLAGGED',
  ROLE: 'ROLE',
  INVITATION: 'INVITATION',
  LEFT: 'LEFT',
  SQUASH: 'SQUASH',
  MOVE: 'MOVE',
  MERGE: 'MERGE',
  UPDATED: 'UPDATED',
  DELETED: 'DELETED'
}

export const RestrictedFeedSources = [
  FeedSources.ACCESO,
  FeedSources.CHANNEL,
  FeedSources.NEWSLETTER,
  FeedSources.PIPE,
  FeedSources.WATSON
]

export const NoFilterFeedSources = [FeedSources.WATSON]

export const WordcloudTypes = {
  TAGS: 'TAGS',
  KEYWORDS: 'KEYWORDS'
}
